/**
 * @description Objeto de URIs de las APIs que el sitio consume
 */
export const urls = {
    typeformUrl: process.env.REACT_APP_HOST_NAME + '/general/api/typeform-data/',
    verifyTokenPasswordRecoveryUrl: process.env.REACT_APP_KITPRO_HOST_NAME + '/general/api/verify-token-password-recovery/',
    ChangePasswordFromPasswordRecoveryUrl: process.env.REACT_APP_KITPRO_HOST_NAME + '/general/api/change-password-from-password-recovery/'
}